import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
import PreDeliveryInspection from "../../../components/desktop/pre-delivery-inspection";
import withReducer from "../../../components/shared/with-reducer";
import injectable from "./injectable";
import GooglemapScript from "../../../components/shared/googlemap-script";

const PreDeliveryInspectionContainer = () => {
    return (
        <ErrorHandler>
            <GooglemapScript />
            <PreDeliveryInspection />
        </ErrorHandler>
    );
};

export default withReducer(injectable)(
    () => ({}),
    (dispatch) => ({ dispatch })
)(withLayout(PreDeliveryInspectionContainer));
